export default __webpack_public_path__ + "static/media/screen5.31f0a55e.png";